import React, { useEffect, useState } from 'react';
import { apiConstants } from '../_constants';
import { subscriptionsService } from '../_services/subscriptions.service';
import './paymenthistory.css';
import { authHeader } from '../_helpers';

const PaymentHistory = () => {
  const [paymentData, setPaymentData] = useState([
    {
      id: 1,
      course_name: 'Course 1',
      date: '2021-01-01',
      amount: 100,
      status: 'success',
      method: 'credit card',
    },
    {
      id: 2,
      course_name: 'Course 2',
      date: '2021-01-01',
      amount: 100,
      status: 'success',
      method: 'credit card',
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [query] = useState({
    pageVo: {
      pageNo: 1,
      noOfItems: 10,
    },
  });

  useEffect(() => {
    getPaymentDetails(1);
  }, []);

  const getPaymentDetails = (pageNo, queryTemp) => {
    let queryNew = queryTemp ? queryTemp : query;
    queryNew.pageNo = pageNo;
    setIsLoading(true);
    subscriptionsService.getPaymentDetails(query).then(
      (res) => {
        setIsLoading(false);
        console.log('getpaymentdetetailsresponse', res);
        if (res?.data?.rows?.length) {
          setPaymentData(res.data.rows);
        } else {
          setPaymentData([]);
        }
      },
      (err) => {
        setIsLoading(false);
        console.error('error', err);
      },
    );
  };

  const downloadInvoice = (payment_id) => {
    console.log('downloadInvoice', payment_id);
    fetch(`${apiConstants.apiUrl}/getinvoicepdf?payment_id=${payment_id}`, {
      method: 'GET',
      headers: authHeader(),
    }).then((response) => {
      response.text().then((text) => {
        const data = text && JSON.parse(text);
        console.log('downloadInvoiceresponse', data);
        if (data?.data?.data?.output_file_name) {
          download(data?.data?.data?.output_file_name);
        }
      });
    });
  };

  const download = async (filename) => {
    let fileUrl = apiConstants.apiUrlInvoice + '/invoice/' + filename;
    window.open(fileUrl, '_blank');
  };

  const renderPaymentList = () => {
    return paymentData.map((payment) => {
      let key = Object.keys(payment)[0];
      let objectIsEmpty = Object.keys(payment[key]).length === 0;
      console.log(objectIsEmpty, 'this is is object empty', key);
      return (
        <div key={payment.id}>
          <div className='monthhead'>{key}</div>
          {!objectIsEmpty &&
            payment[key].map((subData, subindex) => {
              return (
                <div
                  className='course-container'
                  // onClick='navigateToPaymentDetail(subData)'
                  key={subindex}
                >
                  {console.log(subData, 'this is subdata===')}
                  <img
                    src={`${
                      subData.course_image
                        ? apiConstants.imgUrl + subData.course_image
                        : 'img/exam_dummy.jpeg'
                    }`}
                    className='topic-image'
                    alt='Course'
                  />
                  <div className='course-contents'>
                    <div
                      className='row'
                      style={{ flexWrap: 'wrap', justifyContent: 'space-between' }}
                    >
                      <div style={{ width: '100%' }}>
                        <h3 className='course-name mb-1'>{subData?.course_name}</h3>
                        <div className='paymentdate'>{subData?.created_time_string}</div>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='row gap-3'>
                        <div className='row'>
                          <span className='course-content-text'>₹ {subData.amount}</span>
                        </div>
                        {/* <div className='row'>
                          <img src='img/maestro.png' className='topic-img' alt='Payment Method' />
                          <span className='course-content-text'>XX 9368</span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div
                    className='d-flex gap-2 cursor-pointer'
                    onClick={() => {
                      downloadInvoice(subData?._id);
                    }}
                  >
                    <img src='/img/invoice.png' className='invoice-icon' alt='Invoice' />
                    <span className='invoice-text'>Invoice</span>
                  </div>
                </div>
              );
            })}
        </div>
      );
    });
  };
  return (
    <div className='paymenthistory'>
      {console.log(isLoading, 'this is loading and ', paymentData)}
      <div className='container'>
        <div className='paymentheader'>
          <h1 className='paymentlisttitle'>Payments</h1>
          <p className='paymentlistsubtitle'>Payment history & invoices</p>
        </div>
        <div className='listcontainer'>{renderPaymentList()}</div>
      </div>
    </div>
  );
};

export default PaymentHistory;
